import PropTypes from "prop-types"
import { columnsPropTypes, rowsPropTypes } from "./tablePropsTypes"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import BaseTable from "./BaseTable"

const DraggableTable = ({ onDragEnd, ...tableProps }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, _snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <BaseTable
              isDraggable
              draggableType="handle"
              providedPlaceholder={provided.placeholder}
              {...tableProps}
            />
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

DraggableTable.propTypes = {
  onDragEnd: PropTypes.func.isRequired,
  columns: columnsPropTypes,
  rows: rowsPropTypes,
  draggableType: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  onRowClick: PropTypes.func,
  emptyTableMessage: PropTypes.string,
  isSelectable: PropTypes.bool,
  onSelectChange: PropTypes.func,
  selectableField: PropTypes.string,
  isLoading: PropTypes.bool,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  hasTableHeader: PropTypes.bool
}

export default DraggableTable
